import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, SectionHeader } from '../../form';
import { Field, Input, Label } from '@headlessui/react';

const AffiliatePayoutProgram: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <SectionHeader
      title={t('prechecks.affiliatePayoutProgram')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      }
      iconBgColor="bg-amber-100"
      iconTextColor="text-amber-600"
      titleColor="text-amber-600"
    >
      <FormField
        id="apRegNum"
        name="apRegNum"
        label={t('prechecks.companyRegistrationNumber')}
        type="text"
        value={formik.values.apRegNum}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apRegNum}
        touched={formik.touched.apRegNum}
      />

      {/* Custom checkbox field for apProduct since it uses non-standard checkboxes */}
      <Field>
        <Label className="text-base font-semibold text-slate-700 mb-4 block">
          {t('prechecks.pleaseSelectProduct')}
        </Label>
        <div className="bg-white rounded-lg p-4 border border-slate-200">
          {[
            { value: 'Bank Transfers', key: 'bankTransfers' },
            { value: 'Payouts', key: 'payouts' },
            { value: 'Physical Pre-Paid Cards', key: 'physicalPrePaidCards' },
            { value: 'Virtual Pre-Paid Cards', key: 'virtualPrePaidCards' }
          ].map((option, index) => (
            <Field key={index} className="flex items-center mb-2">
              <Input
                type="checkbox"
                name="apProduct"
                value={option.value}
                onChange={formik.handleChange}
                className="w-5 h-5 text-blue-600 bg-white border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out cursor-pointer"
              />
              <Label className="text-base font-medium text-slate-700 ml-3 cursor-pointer">{t(`prechecks.${option.key}`)}</Label>
            </Field>
          ))}
        </div>
        {formik.touched.apProduct && formik.errors.apProduct ? (
          <div className="text-red-700 text-sm mt-2 bg-red-50 border border-red-200 p-2 rounded">{formik.errors.apProduct}</div>
        ) : null}
      </Field>

      <FormField
        id="apUsage"
        name="apUsage"
        label={t('prechecks.foreseenMainUsage')}
        type="text"
        value={formik.values.apUsage}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apUsage}
        touched={formik.touched.apUsage}
      />

      <FormField
        id="apProjVolume"
        name="apProjVolume"
        label={t('prechecks.projectedMonthlyTotalVolumeEURGBP')}
        type="text"
        value={formik.values.apProjVolume}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apProjVolume}
        touched={formik.touched.apProjVolume}
      />

      <FormField
        id="apProjCount"
        name="apProjCount"
        label={t('prechecks.projectedMonthlyTransactionCount')}
        type="text"
        value={formik.values.apProjCount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apProjCount}
        touched={formik.touched.apProjCount}
      />

      <FormField
        id="apAvgTxValue"
        name="apAvgTxValue"
        label={t('prechecks.averageTransactionValue')}
        type="text"
        value={formik.values.apAvgTxValue}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apAvgTxValue}
        touched={formik.touched.apAvgTxValue}
      />

      <FormField
        id="apCardCount"
        name="apCardCount"
        label={t('prechecks.howManyCardsNeeded')}
        type="text"
        value={formik.values.apCardCount}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apCardCount}
        touched={formik.touched.apCardCount}
      />

      <FormField
        id="apCurrencies"
        name="apCurrencies"
        label={t('prechecks.currenciesRequired')}
        type="text"
        value={formik.values.apCurrencies}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.apCurrencies}
        touched={formik.touched.apCurrencies}
      />
    </SectionHeader>
  );
};

export default AffiliatePayoutProgram;
